'use strict';
var config = require('../config.js');

var clientCtrl = function ($scope, Upload, deviceDetector, $location, railApi, $stateParams, $state, $rootScope) {
    $scope.clientData = railApi.index('organizations').data;
    $scope.uploadLogo = function(file, fileType, error) {
        if (file && (undefined === error)) {
            Upload.upload({
                url: config.apiIP + 'organizations/upload_logo?client='+$rootScope.clientSettings.client_id,
                file: file,
                fields: data
            }).progress(function (evt) {
                $scope.icon = "fa fa-spinner fa-spin"
                $scope.color = ""
                $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                location.reload(true);
            }).success(function (data, status, headers, config) {
                // completed, data contains the parsed resume and fileModel
                mapLinguaxResponse(data, fileType);
            }).error(function(data, status, headers, config) {
                $scope.fileError = data.error;
                if (config.fields.type === 'resume') {
                    $scope.errorResume = true;
                }
                else {
                    $scope.errorFile = true;
                }
            });
        }else{
            return false;
        }
        
    };

    $scope.uploadBigLogo = function(file, fileType, error) {
        if (file && (undefined === error)) {
            Upload.upload({
                url: config.apiIP + 'organizations/upload_social_logo?client='+$rootScope.clientSettings.client_id,
                file: file,
                fields: data
            }).progress(function (evt) {
                $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                location.reload();
            }).success(function (data, status, headers, config) {
                // completed, data contains the parsed resume and fileModel
                mapLinguaxResponse(data, fileType);
            }).error(function(data, status, headers, config) {
                $scope.fileError = data.error;
                if (config.fields.type === 'resume') {
                    $scope.errorResume = true;
                }
                else {
                    $scope.errorFile = true;
                }
            });
        }else{
            return false;
        }
        
    };

    $scope.uploadEmailLogo = function(file, fileType, error) {
        const allowedTypes = ['image/jpeg', 'image/png'];
        if (file && (undefined === error) && allowedTypes.includes(file[0].type)) {
            Upload.upload({
                url: config.apiIP + 'organizations/upload_email_logo?client='+$rootScope.clientSettings.client_id,
                file: file,
                fields: data
            }).progress(function (evt) {
                $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                location.reload();
            }).success(function (data, status, headers, config) {
                // completed, data contains the parsed resume and fileModel
                mapLinguaxResponse(data, fileType);
            }).error(function(data, status, headers, config) {
                $scope.fileError = data.error;
                if (config.fields.type === 'resume') {
                    $scope.errorResume = true;
                }
                else {
                    $scope.errorFile = true;
                }
            });
        }else{
            $scope.uploadError = [{error: "Invalid File"}]
        }
        
    };

    $scope.uploadCompEmailSignature = function(file, fileType, error) {
        if (file && (undefined === error)) {
            Upload.upload({
                url: config.apiIP + 'organizations/upload_email_signature?client='+$rootScope.clientSettings.client_id,
                file: file,
                fields: data
            }).progress(function (evt) {
                $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                location.reload();
            }).success(function (data, status, headers, config) {
                // completed, data contains the parsed resume and fileModel
                mapLinguaxResponse(data, fileType);
            }).error(function(data, status, headers, config) {
                $scope.fileError = data.error;
                if (config.fields.type === 'resume') {
                    $scope.errorResume = true;
                }
                else {
                    $scope.errorFile = true;
                }
            });
        }else{
            return false;
        }
        
    };

    $scope.removeEmailBanner = function(client_id, type){
        railApi.put('organizations/1/remove_email_logo', {client_id: client_id, type: type}, 'organizations').promise.then(function(data){
            location.reload(true);
        })
    }

    $scope.removeEmailHeader = function(header_id){
        railApi.put('organizations/1/remove_email_logo', {header_id: header_id, type: 'email_header_graphic'}, 'organizations').promise.then(function(data){
            location.reload(true);
        })
    }

    $scope.company_departments = railApi.index('company_departments', 'company_department').data

    $scope.editingIndex = null;
    $scope.oldValue = []
    $scope.changeActive = function(editing_index){
        $scope.editingIndex = editing_index
        if(typeof(editing_index) == 'number'){
            $scope.oldValue = angular.copy($scope.clientData[0].filtered_headers[editing_index]);
        }
    }

    $scope.cancelEdit = function(index) {
        $scope.restore_old_logo_val(index);
        $scope.editingIndex = null;
    };

    $scope.restore_old_logo_val = function(index){
        $scope.clientData[0].filtered_headers[index] = $scope.oldValue
    }

    
    $scope.saveLogoChanges = function(id, name, notes, department_id, is_automated_default){
        if(is_automated_default){
            department_id = ""
        }else{
            department_id = department_id
        }
        $scope.changeActive()
        railApi.put('organization_files/'+ id, {name: name, 
                                                notes: notes, 
                                                company_department_id: department_id, 
                                                is_automated_default: is_automated_default}, 'organization_file').promise.then(function(data){
                                                    if(department_id){
                                                        _.find($scope.clientData[0].filtered_headers, {id: data.id}).company_department.title = data.company_department.title
                                                    }else{
                                                        _.find($scope.clientData[0].filtered_headers, {id: data.id}).company_department = null
                                                    }
                                                })
        
    }

    
};

module.exports = clientCtrl;